import React from 'react';

import Text from '~components/atoms/Text';

import { useAppSelector } from '~redux/hooks';
import { FundTypeEnum, SilverTypeEnum } from '~utils/enums';

import * as Styles from './_paperSilverTable.module.scss';
import CustomSkeleton from '~components/atoms/Skeleton';

const PaperSilverTable = () => {
    const dashboardSilverProductInventory = useAppSelector(state => state.dashboard.dashboardSilverProductInventory);
    const loading = useAppSelector(state => state.dashboard.loadings.getDashboardProductInventory);
    const error = useAppSelector(state => state.dashboard.errors.getDashboardProductInventory);

    const filters = useAppSelector(state => state.dashboard.dashboardSilverProductInventoryFilters);

    const tableHeader = [
        'Denomination',
        'Quantity (pcs)',
        'Total Weight (gram)',
    ];

    const paperSilverInventory = dashboardSilverProductInventory.filter(product => product.silverType === SilverTypeEnum.PaperSilver && product.fundType === FundTypeEnum.Islamic);

    const combinedInventory = {
        productName: paperSilverInventory[0]?.productName,
        amount: paperSilverInventory[0]?.paperSilverBlockAmount,
        paperSilverWeight: paperSilverInventory.reduce((acc, product) => acc + product.paperSilverWeight, 0),
    };

    const renderTableHeader = () => {
        return tableHeader.map((header, index) => {
            return (
                <th key={index}>
                    {header}
                </th>
            );
        });
    };

    const renderTableBody = () => {
        if (loading) {
            return (
                <tr>
                    <td colSpan={3}>
                        <CustomSkeleton height={40} />
                    </td>
                </tr>
            );
        }

        if (error) {
            return (
                <tr>
                    <td colSpan={3}>
                        <Text
                            label={error}
                            isError
                        />
                    </td>
                </tr>
            );
        }

        if (!paperSilverInventory.length) {
            return (
                <tr>
                    <td colSpan={3}>
                        <Text
                            label='No data found'
                            isError
                        />
                    </td>
                </tr>
            );
        }

        if (filters.branchCode === '') {
            return (
                <tr>
                    <td>{combinedInventory.productName}</td>
                    <td>{combinedInventory.amount}</td>
                    <td>{typeof combinedInventory.paperSilverWeight === 'number' ? combinedInventory.paperSilverWeight.toFixed(3) : '-'}</td>
                </tr>
            );
        }

        return paperSilverInventory.sort((a, b) => a.productId - b.productId).map((product, index) => {
            return (
                <tr key={index}>
                    <td>{product.productName}</td>
                    <td>{product.paperSilverBlockAmount}</td>
                    <td>{typeof product.paperSilverWeight === 'number' ? product.paperSilverWeight.toFixed(3) : '-'}</td>
                </tr>
            );
        });
    };

    return (
        <div className={Styles.container}>
            <Text
                label='Paper Silver'
                className={Styles.title}
                isBold
            />

            <table className={Styles['table-container']}>
                <thead>
                    <tr>
                        {renderTableHeader()}
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td colSpan={3} />
                    </tr>

                    {renderTableBody()}
                </tbody>
            </table>
        </div>
    );
};

export default PaperSilverTable;
